module.exports = __webpack_public_path__ + "staticV3/img/f6cffced.find-product-fail.png";